import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormVersionPayload, AdminFormVersionResponse } from '../types'

/**
 * Creates a version under a form (`POST /api/forms/{formReferenceID}/versions`). The parent form reference
 * is only known at runtime (after the form itself is created), so it is passed in and the path is built
 * from it; the hook stays inert (empty path, never invoked) until a reference is supplied.
 */
export const useCreateAdminFormVersion = (formReferenceID: string | null) =>
  useAdminUpdate<AdminFormVersionPayload, AdminFormVersionResponse>({
    path: formReferenceID ? `/api/forms/${formReferenceID}/versions` : '',
    method: 'POST',
    errorMessage: 'Failed to create the form version',
    successMessage: 'Form created',
  })
